// icons

import HRM_ICON from "../../../../images/hrm.svg";
import INVENTORY_ICON from "../../../../images/inventory.svg";
import ITS_ICON from "../../../../images/its.svg";
import TM_ICON from "../../../../images/tm.svg";
import PRM_ICON from "../../../../images/prm.svg";
import TICKETS_ICON from "../../../../images/tickets.svg";

// bg images

import HRM_BG_IMG from "../../../../images/hrm_bg.png";
import INVENTORY_BG_IMG from "../../../../images/inventory_bg.png";
import ITS_BG_IMG from "../../../../images/it_inventory_bg.png";
import TM_BG_IMG from "../../../../images/task_management_bg.png";
import PRM_BG_IMG from "../../../../images/procurement_bg.png";
import TICKETS_BG_IMG from "../../../../images/it_ticket_bg.png";

export const modules = [
  {
    value: "HRM",
    label: "MODULE.HRM",
    icon: HRM_ICON,
    bgImage: HRM_BG_IMG,
  },
  {
    value: "INVENTORY",
    label: "MODULE.INVENTORY",
    icon: INVENTORY_ICON,
    bgImage: INVENTORY_BG_IMG,
  },
  {
    value: "ITS",
    label: "MODULE.ITS",
    icon: ITS_ICON,
    bgImage: ITS_BG_IMG,
  },
  {
    value: "TM",
    label: "MODULE.TM",
    icon: TM_ICON,
    bgImage: TM_BG_IMG,
  },
  {
    value: "PROCUREMENT",
    label: "MODULE.PR",
    icon: PRM_ICON,
    bgImage: PRM_BG_IMG,
  },
  {
    value: "TICKETS",
    label: "MODULE.TICKETS",
    icon: TICKETS_ICON,
    bgImage: TICKETS_BG_IMG,
  },
];
